export default __webpack_public_path__ + "static/media/Python.80a074a6.png";